import React from 'react';
import { Button, Layout as AntLayout, Menu, Dropdown, Space, Avatar } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';
import { logout } from './../../redux/userSlice';
import './layout.css';
import { 
  DashboardOutlined, 
  UserOutlined, 
  ProfileOutlined, 
  LogoutOutlined, 
  SettingOutlined,
  MenuOutlined
} from '@ant-design/icons';
import logo from './../../assets/img/logo-vsp.png';

const { Header, Content, Footer } = AntLayout;

const PageLayout = ({ children }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { currentUser } = useSelector((state) => state.user);

  const handleLogout = () => {
    dispatch(logout());
    navigate('/login');
  };

  const handleNavigation = (path) => {
    navigate(path);
  };

  const userMenu = (
    <Menu>
      <Menu.Item key="profile" icon={<ProfileOutlined />} onClick={() => handleNavigation('/profile')}>
        Profile
      </Menu.Item>
      {currentUser?.role === 'admin' && (
        <Menu.Item key="users" icon={<UserOutlined />} onClick={() => handleNavigation('/admin/users')}>
          Users
        </Menu.Item>
      )}
      <Menu.Divider />
      <Menu.Item key="logout" icon={<LogoutOutlined />} onClick={handleLogout}>
        Logout
      </Menu.Item>
    </Menu>
  );

  const isActive = (path) => {
    return location.pathname === path;
  };

  return (
    <AntLayout className="layout">
      <Header className="layout-header">
        <div className="logo" onClick={() => handleNavigation('/dashboard')} style={{ cursor: 'pointer' }}>
          <img src={logo} alt="Logo" />
        </div>
        <div className="menu-buttons">
          {currentUser ? (
            <>
              <Button 
                type={isActive('/dashboard') ? 'primary' : 'default'}
                icon={<DashboardOutlined />} 
                onClick={() => handleNavigation('/dashboard')}
              >
                Dashboard
              </Button>
              <Dropdown overlay={userMenu} trigger={['click']}>
                <Button>
                  <Space>
                    <Avatar size="small" icon={<UserOutlined />} />
                    {currentUser.name}
                  </Space>
                </Button>
              </Dropdown>
            </>
          ) : (
            <Button 
              type="primary" 
              icon={<UserOutlined />} 
              onClick={() => handleNavigation('/login')}
            >
              Login
            </Button>
          )}
        </div>
      </Header>
      <Content className="layout-content">
        {children}
      </Content>
      <Footer className="layout-footer">
        ©{new Date().getFullYear()} Value Sales Presentation. All rights reserved.
      </Footer>
    </AntLayout>
  );
};

export default PageLayout;
